module.exports = __webpack_public_path__ + "img/Zimbabwe.40e631d0.gif";